<template>
  <div v-if="data" class="course">
    <div class="course-header">
      <span class="course-header__icon">
        <IconComponent name="calendar" />
      </span>
      <div class="course-header__info">
        <span class="course-header__date">{{ data.date }}</span>
        <h4 class="course-header__title">{{ data.title }}</h4>
      </div>
      <button @click="$emit('claimCreate', data)" type="button" class="btn btn--md btn--main">
        Регистрация
      </button>
    </div>
    <div v-if="data.events && data.events.length" class="course-body">
      <div class="course-events">
        <div v-for="(item, i) in data.events" :key="i" class="course-event">
          <span class="course-event__time">{{ item.time }}</span>
          <span class="course-event__info">
            <span class="course-event__title">{{ item.title }}</span>
            <span v-if="item.speaker" class="course-event__speaker"
              >Лектор: {{ item.speaker.title }}, {{ item.speaker.description }}</span
            >
          </span>
        </div>
      </div>
    </div>
    <div v-if="$options.filters.editor_has_text(data.comment)" class="course-footer">
      <EditorJSComponent :text="data.comment" />
    </div>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";
import EditorJSComponent from "components/EditorJSComponent.vue";

export default {
  name: "CourseComponent",
  props: {
    data: Object,
  },
  components: { IconComponent, EditorJSComponent },
};
</script>

<style lang="stylus">
.course {
  background: var(--white);
  box-shadow: 0 10px 15px var(--black_o05);
  border-radius: 15px;
  width: 100%
  max-width: 625px
  +below(860px) {
    max-width: 550px
  }
  +below(768px) {
    max-width: 500px
  }

  > *:not(:last-child) {
    border-bottom: 1px solid var(--gray)
  }

  &-header {
    padding: 30px
    display: flex
    align-items: center
    gap: 15px
    +below(860px) {
      padding: 15px
    }
    +below(580px) {
      flex-wrap: wrap
    }

    &__icon {
      display: flex
      flex-shrink: 0
      padding: 15px
      border-radius: 50%
      border 1px solid var(--main-color-75)
      +below(860px) {
        padding: 10px
      }

      .icon {
        width: 30px
        height: 30px
        +below(860px) {
           width: 25px
          height: 25px
        }

        svg path {
          stroke var(--main-color-75)
        }
      }
    }

    &__info {
      display: flex
      flex-direction: column
      gap: 5px
      font-weight: 700;
      font-size: 1.125em
      line-height: 140%;
      +below(860px) {
        gap: 0
        font-size: 1em
      }
    }

    &__title {
      margin: 0
    }

    .btn {
      flex-shrink: 0
      margin-left: auto
      +below(580px) {
        width: 100%
      }
    }
  }

  &-body {
    padding: 15px 30px
    +below(860px) {
      padding: 15px
    }
  }

  &-events {
    display: flex
    flex-direction: column
    gap: 15px
  }

  &-event {
    display: flex
    align-items: flex-start
    gap: 20px
    +below(480px) {
      flex-direction: column
      gap: 5px
    }

    &__time {
      font-weight: 700;
      font-size: 1.125em
      line-height: 140%;
      flex-shrink: 0
    }

    &__info {
      display: flex
      flex-direction: column
      line-height: 170%;
    }

    &__title {
      font-weight: 700
    }
  }

  &-footer {
    padding: 30px
    +below(860px) {
      padding: 15px
    }
  }
}
</style>
